import BlindsAndShuttersInstallationInformation from "./BlindsAndShuttersInstallationInformation";

export default BlindsAndShuttersInstallationInformation